"use strict";

import "./POISelector.css";
import React from "react";
import lang from "vwa/lang";
import Button from "vwa/components/Button";
import Picker from "vwa/components/Picker";
import MultiSelector from "vwa/components/MultiSelector";

export default class POISelector extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			shown: false
		};
	}
	
	toggle() {
		this.setState({shown: !this.state.shown});
	}
	
	getPOIOptions() {
		return (this.props.pois || []).map(
			poi => ({
				value: poi._id,
				label: poi.name
			})
		);
	}
	
	render() {
		return (
			<Button
				className="POISelector"
				icon="filter"
				onClick={() => this.toggle()}
			>
				<Picker
					className="POISelectorPicker"
					shown={this.state.shown}
					onWindowClick={() => this.setState({shown: false})}
				>
					<MultiSelector
						title={lang.SELECT_POIS}
						options={this.getPOIOptions()}
						onChange={this.props.onChange}
					/>
				</Picker>
			</Button>
		);
	}
	
}

POISelector.propTypes = {
	pois: React.PropTypes.arrayOf(React.PropTypes.shape),
	onChange: React.PropTypes.func
};

POISelector.defaultProps = {
	pois: [],
	onChange: poiIds => {}
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossings/POISelector/POISelector.jsx